import './Banner.css';
import Form, { FormProps } from '..';
import useStore from '../../Hooks/useStore';
import Element from '../../Element';

interface BannerPostProps extends FormProps {}

export default function BannerPost({
  children,
  className = '',
  ...rest
}: BannerPostProps) {
  const [getters, setters] = useStore();

  const {
    form: { setForm, setBatchForm },
    banner: { updateBannerLayout, applyFormFragment },
  } = setters;

  const {
    form: { getElements, getShowSingleForm },
    banner: {
      getBanner,
      getDynamics,
      getSizeItems,
      getOrientationItems,
      getLayoutItems,
      getCampaignItems,
    },
  } = getters;

  const elements = getElements('model');
  const onSubmit = (e: any) => {
    e.preventDefault();
  };

  return (
    <Form.Banner
      className={`form-banner ${className}`}
      onSubmit={onSubmit}
      {...rest}
    >
      <Form.Input.Dropdown
        className="form-banner-field"
        errorMessage={false}
        items={getDynamics()}
        label="Dinâmica Comercial"
        value={getBanner('dynamics')[getShowSingleForm('model.dynamic')]}
        onSelected={(item) => {
          const selectedDynamic = item.id as keyof Dynamics;
          // applyFormFragment(selectedDynamic);
          setBatchForm('model.dynamic', selectedDynamic);
          updateBannerLayout();
        }}
      />

      <Form.Input.Dropdown
        className="form-banner-field"
        errorMessage={false}
        items={getSizeItems()}
        label="Tamanho"
        value={
          getSizeItems().find(
            ({ id }) => getShowSingleForm('model.size') === id,
          )?.name
        }
        onSelected={(item) => {
          setBatchForm('model.size', item.id as any);
          updateBannerLayout();
        }}
      />

      <Form.Input.Dropdown
        className="form-banner-field"
        errorMessage={false}
        items={getOrientationItems()}
        label="Orientação"
        value={
          getOrientationItems().find(
            ({ id }) => getShowSingleForm('model.orientation') === id,
          )?.name
        }
        onSelected={(item) => {
          setBatchForm('model.orientation', `${item.id}` as OrientationsType);
          updateBannerLayout();
        }}
      />

      <Form.Input.Dropdown
        className="form-banner-field"
        errorMessage={false}
        items={getLayoutItems()}
        label="Layout Coordenada"
        value={getShowSingleForm('model.layout')}
        onSelected={(item) => {
          setBatchForm('model.layout', `${item.id}`);
          updateBannerLayout();
        }}
      />

      <Form.Input.Dropdown
        className="form-banner-field"
        errorMessage={false}
        items={getCampaignItems()}
        label="Campanha"
        value={getShowSingleForm('model.campaign')}
        onSelected={(item) => {
          setBatchForm('model.campaign', `${item.id}`);
          updateBannerLayout();
        }}
      />

      <Element elements={elements} />
    </Form.Banner>
  );
}
